module.exports = __webpack_public_path__ + "img/image-(3)_thumbnail.b6036fcc.jpg";